import { render, staticRenderFns } from "./ExceptionForm.vue?vue&type=template&id=3b400a88&"
import script from "./ExceptionForm.vue?vue&type=script&lang=js&"
export * from "./ExceptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports